module.exports = __webpack_public_path__ + "img/p4.35bb26f.jpg";